interface FooterProps {
  companyName: string;
  companyNameZh: string;
  slogan: string;
  copyright: string;
  navItems: { label: string; href: string }[];
}

export default function Footer({
  companyName,
  companyNameZh,
  slogan,
  copyright,
  navItems,
}: FooterProps) {
  return (
    <footer className="py-16 px-6 border-t border-white/10">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Logo and company */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[var(--cyan-electric)] to-[var(--amber-warm)] flex items-center justify-center font-bold text-[var(--navy-deep)]">
              F
            </div>
            <div>
              <div className="font-semibold text-lg">{companyName}</div>
              <div className="text-sm text-gray-500">{companyNameZh}</div>
            </div>
          </div>

          {/* Nav links */}
          <div className="flex items-center gap-6">
            {navItems.map((item, i) => (
              <a
                key={i}
                href={item.href}
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Slogan and copyright */}
          <div className="text-center md:text-right">
            <div className="text-gray-400 text-sm mb-2">{slogan}</div>
            <div className="text-gray-500 text-xs">{copyright}</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
